import {Component, Inject} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ConfirmDialog} from './confirmDialog';

@Component({
  selector: 'sura-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {

  constructor(public dialogConfirm: MatDialogRef<ConfirmDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: ConfirmDialog) {
  }

  closeConfirmDialog() {
    this.dialogConfirm.close();
  }

  confirmDialog() {
    this.data.flagRespuesta = true;
    this.dialogConfirm.close(this.data);
  }
}
